import React from 'react';
import { ArrowRightIcon, ClipboardCheckIcon, WrenchIcon } from 'lucide-react';
import { useLanguage } from '../hooks/useLanguage';
import { featuredServices, learnMore, supportServices } from '../data/services';
import { ui } from '../data/translations';
const supportIcons = [WrenchIcon, ClipboardCheckIcon];
export function Services() {
  const {
    t
  } = useLanguage();
  return <section id="services" className="w-full bg-white py-20 lg:py-28" data-id="element-199" data-mp="13vl7cb8xcv0f">
      <div className="mx-auto max-w-7xl px-5 lg:px-8" data-id="element-200" data-mp="13xxtz1pmntjt">
        <div className="max-w-2xl" data-id="element-201" data-mp="z43fccovq4rl">
          <h2 className="font-display text-3xl font-bold leading-tight text-navy lg:text-4xl" data-id="element-202" data-mp="z31rt8qofpsz">{t(ui.services.title)}</h2>
          <p className="mt-4 text-steel" data-id="element-203" data-mp="q4gfhvbst70n">{t(ui.services.subtitle)}</p>
        </div>

        <div className="mt-12 grid gap-10 md:grid-cols-2 md:gap-8" data-id="element-204" data-mp="q2n4y4y2e2nd">
          {featuredServices.map(service => <article key={service.image} className="group flex flex-col" data-id="element-205" data-mp="g6agblhdmezh">
              <div className="overflow-hidden rounded-lg bg-mist" data-id="element-206" data-mp="g8dbsl1at0bl">
                <img src={service.image} alt={t(service.alt)} loading="lazy" className="aspect-[3/2] w-full object-cover transition-transform duration-300 ease-snappy group-hover:scale-[1.03]" data-id="element-207" data-mp="36boacyq5aedb" />
              </div>
              <h3 className="mt-6 font-display text-2xl font-bold text-navy" data-id="element-208" data-mp="32bnwpgave77b">{t(service.title)}</h3>
              <p className="mt-3 text-steel" data-id="element-209" data-mp="3q1rvnad45irz">{t(service.description)}</p>
              <ul className="mt-4 flex flex-wrap gap-2" aria-label={`${t(service.title)} ${t(ui.services.includes)}`} data-id="element-210" data-mp="3u2bucidc4ug8">
                {service.tags.map(tag => <li key={tag.en} className="rounded-full bg-mist px-3 py-1 text-xs font-medium text-ink" data-id="element-211" data-mp="3l1dorvn90evj">
                    {t(tag)}
                  </li>)}
              </ul>
              <a href="#contact" className="mt-auto inline-flex items-center gap-2 pt-6 font-display text-sm font-semibold text-navy hover:text-gold-dark" data-id="element-212" data-mp="24pgqk1yx46su">
                {t(learnMore)}
                <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-213" data-mp="1li8wx253bhu8" />
              </a>
            </article>)}
        </div>

        <div className="mt-14 grid border-t border-black/10 md:grid-cols-2" data-id="element-214" data-mp="1gpxyy4twu64b">
          {supportServices.map((service, i) => {
          const Icon = supportIcons[i];
          return <article key={service.title.en} className={`flex gap-5 border-b border-black/10 py-8 md:border-b-0 ${i === 0 ? 'md:border-r md:pr-10' : 'md:pl-10'}`} data-id="element-215" data-mp="16v60kysi7f8h" data-mpi={i}>
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-md bg-navy text-gold" data-id="element-216" data-mp="xv0t6onb8gub">
                  <Icon className="h-6 w-6" aria-hidden="true" data-id="element-217" data-mp="sw69lkhiqo95" />
                </span>
                <div className="flex flex-col" data-id="element-218" data-mp="2s4uzaavjohqz">
                  <h3 className="font-display text-lg font-semibold text-navy" data-id="element-219" data-mp="2n7l4efpdzdvr">{t(service.title)}</h3>
                  <p className="mt-2 text-sm text-steel" data-id="element-220" data-mp="2us5d9wkb1y64">{t(service.description)}</p>
                  <a href="#contact" className="mt-4 inline-flex items-center gap-2 font-display text-sm font-semibold text-navy hover:text-gold-dark" data-id="element-221" data-mp="2zpx5krov3mau">
                    {t(service.cta)}
                    <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-222" data-mp="39fgq01s83o7t" />
                  </a>
                </div>
              </article>;
        })}
        </div>
      </div>
    </section>;
}